import { render, staticRenderFns } from "./mbDrawer.vue?vue&type=template&id=70435e7a&scoped=true"
import script from "./mbDrawer.vue?vue&type=script&lang=js"
export * from "./mbDrawer.vue?vue&type=script&lang=js"
import style0 from "./mbDrawer.vue?vue&type=style&index=0&id=70435e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70435e7a",
  null
  
)

export default component.exports